import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CrmSegmentDefinitionDto } from '../../models/crm-segment-definition.dto';
import { CrmSegmentDefinitionsFormPanelComponent } from '../crm-segment-definitions-form-panel/crm-segment-definitions-form-panel.component';
import { CrmSegmentDefinitionsListComponent } from '../crm-segment-definitions-list/crm-segment-definitions-list.component';
import { CrmSegmentDefinitionsToolbarComponent } from '../crm-segment-definitions-toolbar/crm-segment-definitions-toolbar.component';

@Component({
  selector: 'app-crm-segment-definitions-main',
  standalone: true,
  imports: [
    CommonModule,
    CrmSegmentDefinitionsToolbarComponent,
    CrmSegmentDefinitionsListComponent,
    CrmSegmentDefinitionsFormPanelComponent,
  ],
  templateUrl: './crm-segment-definitions-main.component.html',
  styleUrl: './crm-segment-definitions-main.component.scss',
})
export class CrmSegmentDefinitionsMainComponent {
  reloadVersion = 0;
  showFormPanel = false;
  selectedSegmentId: number | null = null;

  openAddPanel(): void {
    this.selectedSegmentId = null;
    this.showFormPanel = true;
  }

  openEditPanel(segment: CrmSegmentDefinitionDto): void {
    this.selectedSegmentId = segment.id;
    this.showFormPanel = true;
  }

  onFormVisibilityChange(visible: boolean): void {
    this.showFormPanel = visible;

    if (!visible) {
      this.selectedSegmentId = null;
    }
  }

  onSaved(): void {
    this.selectedSegmentId = null;
    this.reloadVersion++;
  }

  onDeleted(): void {
    this.reloadVersion++;
  }
}
